<template>
  <div class="edit-predicted-income-wo-actual">
    <colored-line-popup :class="'success'" :close-action="closeAction">

      <template v-slot:top-content>
        <div class="income-title">
          <span class="name">צפי הכנסה קבועה</span>
          • <span class="category">{{ predictedTransaction.expense }}</span>
        </div>
        <transaction-amount :amount="predictedTransaction.predictedAmount" :class="'income'"/>
        <prediction-details :predicted-transaction="predictedTransaction" />
      </template>
      <template v-slot:footer>
        <div class="cancel" v-on:click="onCancelPredictedTransaction">
          <img class="trash" :src="require('@/assets/icons/blacktrash.svg')">
          <span class="text">מחיקת צפי הכנסה</span>
        </div>
      </template>

    </colored-line-popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../../../../Segment';
import TransactionAmount from '../TransactionAmount.vue';
import PredictionDetails from '../PredictionDetails.vue';

export default {
  name: 'EditPredictedIncomeWOActual',
  components: {
    ColoredLinePopup: BaseUI.ColoredLinePopup,
    PlainDropdown: BaseUI.PlainDropdown,
    RiseupButton: BaseUI.RiseupButton,
    TransactionAmount,
    PredictionDetails,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
    nextAction: {
      type: Function,
      required: true,
    },
  },
  created() {
    Segment.trackUserInteraction('EditPredictedIncomeWOActual_Shown', {
      predictedTransaction: this.predictedTransaction,
    });
  },
  methods: {
    onCancelPredictedTransaction() {
      Segment.trackUserInteraction('EditPredictedIncomeWOActual_CancelPredictionClicked', {
        predictedTransaction: this.predictedTransaction,
      });
      this.nextAction();
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .edit-predicted-income-wo-actual {
    text-align: right;

    .income-title {
      font-weight: bold;
      color: $riseup_green;
      margin-bottom: 24px;
      line-height: 10px;

      .category {
        font-weight: normal;
      }
    }

    .transaction-amount {
      margin-bottom: 12px;
    }

    .cancel {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      color: $riseup_black;
      cursor: pointer;

      .trash {
        margin-left: 3px;
        height: 16px;
      }

      .text {
        text-decoration: underline;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/EditPredictedIncomeWOActual.vue